@if (organizationDetail$ | async; as organizationDetail) {
  @if (!hideTitle()) {
    <h2 class="title-imprint">{{'imprint_data_protection' | translate}}</h2>
  }
  <div class="text-imprint" [innerHtml]="textImprint"></div>
  <div class="text-imprint" [innerHtml]="textDataProtection"></div>
}
<p>
  {{version}}
</p>
<p>
  {{userId$ | async}}
</p>
